"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventFormatterType = void 0;
var EventFormatterType;
(function (EventFormatterType) {
    EventFormatterType["Client"] = "Client";
    EventFormatterType["Server"] = "Server";
})(EventFormatterType = exports.EventFormatterType || (exports.EventFormatterType = {}));
//# sourceMappingURL=EventFormatterType.js.map